const log = (...args) => {
  if (process.env.NODE_ENV !== 'test') {
    console.log('[Raven]', ...args)
  }
}

export default {
  setUserContext(obj) {
    log('set user context:', obj)
  },
  context(initFunc) {
    initFunc()
  },
  config(dsn, config) {
    log('setting global config', { ...config, dsn })
    return this
  },
  install() {
    log('running in dev mode (not reporting)')
  },
  captureException(error) {
    log('exception captured:', error)
  }
}



// WEBPACK FOOTER //
// ./src/lib/raven.development.js